import * as React from 'react';
import { Locales } from '@grandvisionhq/state';

const DEFAULT_ALGOLIA_CONFIG = {
    isEnabled: false,
    algoliaInstantSearchProps: {
        indexName: '',
        searchState: {},
        onStateChange: ()=>{},
        searchClient: {}
    },
    facets: [],
    pageSize: 24,
    sortIndices: [],
    presetQueryObject: {},
    ruleContexts: [],
    indices: [],
    locale: Locales['en-GB'],
    isMultilingualEnabled: false
};
const AlgoliaConfig = /*#__PURE__*/ React.createContext(DEFAULT_ALGOLIA_CONFIG);
const useAlgoliaConfig = ()=>React.useContext(AlgoliaConfig)
;

export { AlgoliaConfig, useAlgoliaConfig };
//# sourceMappingURL=AlgoliaConfig.js.map
